import { Layout } from 'antd';
import { logoTransparent } from 'assets/images';
import { useDispatch } from 'react-redux';
import { UPDATE_LEGAL_COUNTRY_LANGUAGE } from 'state/global/legal/action';
import PropTypes from 'prop-types';
import {
  DEFAULT_LEGAL_COUNTRY_LANGUAGE,
  LEGAL_COUNTRIES_LANGUAGES
} from 'util/config/constant';
import { BaseSelect } from 'components/UI/BaseSelect';
import { Link } from 'react-router-dom';
import { routePaths } from 'routes/route-paths';

const LegalHeader = ({ legalLoggedVersion }) => {
  const { Header } = Layout;
  const dispatch = useDispatch();

  const onChangeLanguage = (languageCode) => {
    dispatch({
      type: UPDATE_LEGAL_COUNTRY_LANGUAGE,
      payload: {
        languageCode
      }
    });
  };

  return (
    <Header className="legal-header">
      {!legalLoggedVersion && (
        <Link to={routePaths.login} className="logo-img-wrapper">
          <img src={logoTransparent} alt="logo" className="logo-img" />
        </Link>
      )}

      <BaseSelect
        className="custom-select translation-switcher"
        onChange={onChangeLanguage}
        listItemHeight={32}
        defaultValue={DEFAULT_LEGAL_COUNTRY_LANGUAGE}>
        {LEGAL_COUNTRIES_LANGUAGES.map((option) => (
          <BaseSelect.Option key={option.value} value={option.value}>
            <div>
              <img
                src={`/assets/images/icons/country/${option.icon}.svg`}
                alt={option.label}
                width="16"
                className="language-selection-country-icon"
              />
              &nbsp;&nbsp;
              {option.label}
            </div>
          </BaseSelect.Option>
        ))}
      </BaseSelect>
    </Header>
  );
};

LegalHeader.defaultProps = {
  legalLoggedVersion: false
};

LegalHeader.propTypes = {
  legalLoggedVersion: PropTypes.bool
};

export default LegalHeader;
